// eslint-disable-next-line import/prefer-default-export
const START = "start";
const END = "end";
const NO_PREFERENCE = "noPreference";
const START_OR_END = "startOrEnd";

export const VtoCoverageRequiredEdge = Object.freeze({
    [START]: 1,
    [END]: 2,
    [START_OR_END]: 3,
    [NO_PREFERENCE]: 0,
});

export const VtoCoverageRequiredEdgeNames = Object.freeze({
    1: START,
    2: END,
    3: START_OR_END,
    0: NO_PREFERENCE,
});
